/*
  Kelly & Windsor Variant Content Switcher

  Any variant-specific content should use:

  data-variant-content
  data-variant-id="{{ v.id }}"

  The script will automatically show/hide the matching content
  when the variant changes.
*/
console.log('custom-product.js loaded');

function showVariantContent(variantId) {
  if (!variantId) return;

  document.querySelectorAll('[data-variant-content]').forEach(function (el) {
    el.classList.toggle(
      'is-active',
      el.dataset.variantId === String(variantId)
    );
  });
}

function getCurrentVariantId() {
  const variantInput = document.querySelector('input[name="id"], select[name="id"]');
  return variantInput ? variantInput.value : null;
}

document.addEventListener('DOMContentLoaded', function () {
  showVariantContent(getCurrentVariantId());

  document.addEventListener('change', function () {
    setTimeout(function () {
      showVariantContent(getCurrentVariantId());
    }, 50);
  });

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      showVariantContent(event.detail.variant.id);
    }
  });
});